import Repository from '../Repository';

export default {

	activateUser(userId) {
		var response = Repository.patch('User/ActivateUser', {
			userId: userId
		});
		return response;
	},

	addUser(emailAddress, firstname, surname, password, vendorCode, roleId, languageId, subjectId, qualificationId) {
		var response = Repository.post('User/AddUser', {
			emailAddress: emailAddress,
			firstname: firstname,
			surname: surname,
			password: password,
			vendorCode: vendorCode,
			roleIdCSV: '' + roleId,
			languageIdCSV: '' + languageId,
			subjectIdCSV: '' + subjectId,
			qualificationIdCSV: '' + qualificationId
		});
		return response;
	},

	authenticate(email, password) {
		var response = Repository.post('User/Authenticate', {
			email: email,
			password: password,
		});
		return response;
	},

	authenticateExternalToken(token) {
		var response = Repository.post('User/Authenticate', {
			externalLoginToken: token
		});
		return response;
	},

	deactivateUser(userId) {
		var response = Repository.patch('User/DeactivateUser', {
			userId: userId
		});
		return response;
	},

	getBatchMarkers(pageSize, pageNumber, searchString, batchId) {
		var response = Repository.get('User/getBatchMarkers', {
			params: {
				pageSize: pageSize,
				pageNumber: pageNumber,		
				searchString: searchString,			
				batchId: batchId,
			}
		});
		return response;
	},


	getClaims() {
		var response = Repository.get('User/GetClaims', {});
		return response;
	},

	getMarkers(pageSize, pageNumber, searchString, qualificationId, languageId, subjectId, assessmentTypeId, assessmentCodeIds, periodId, roleIds, tutorCentres, invigilators) {
		
		var response = Repository.get('User/GetMarkers', {
			params: {
				pageSize: pageSize,
				pageNumber: pageNumber,		
				searchString: searchString,			
				qualificationIdCSV: (qualificationId > 0) ? qualificationId : '',
				languageIdCSV: (languageId > 0) ? languageId : '',
				subjectIdCSV: (subjectId > 0) ? subjectId : '',
				assessmentTypeIdCSV: (assessmentTypeId > 0) ? assessmentTypeId : '',
				assessmentCodeIdCSV: (assessmentCodeIds == null) ? null : assessmentCodeIds.join(','),
				periodIdCSV: (periodId > 0) ? periodId : '',
				roleIDCSV: (roleIds == null) ? null : roleIds.join(','),
				tutorCentreCSV: (tutorCentres == null) ? null : tutorCentres.join(','),
				invigilatorCSV: (invigilators == null) ? null : invigilators.join(','),
			}
		});
		return response;
	},

	getStudents() {
		var response = Repository.get('User/GetStudents', {
			params: {
			}
		});
		return response;
	},

	getUser(userId) {
		var response = Repository.get('User/GetUser', {
			params: {
				userId: userId
			}
		});
		return response;
	},

	getUsers(pageSize, pageNumber, searchString, languageIds, qualificationIds, subjectIds, roleIds) {
		var response = Repository.get('User/GetUsers', {
			params: {
				pageSize: pageSize,
				pageNumber: pageNumber,			
				LanguageIdCSV: (languageIds == null) ? null : languageIds.join(','),
				QualificationIdCSV: (qualificationIds == null) ? null : qualificationIds.join(','),
				SubjectIdCSV: (subjectIds == null) ? null : subjectIds.join(','),
				RoleIdCSV: (roleIds == null) ? null : roleIds.join(','),
				SearchString: searchString,
				IsActive: true
			}
		});
		return response;
	},

	getUsersCsv(searchString, languageIds, qualificationIds, subjectIds, roleIds) {
		var response = Repository.get('User/GetUsersCSV', {
			responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/csv',
                'Accept': 'application/csv'
            },					
			params: {
				LanguageIdCSV: (languageIds == null) ? null : languageIds.join(','),
				QualificationIdCSV: (qualificationIds == null) ? null : qualificationIds.join(','),
				SubjectIdCSV: (subjectIds == null) ? null : subjectIds.join(','),
				RoleIdCSV: (roleIds == null) ? null : roleIds.join(','),
				Csv: true,
				SearchString: searchString,
				IsActive: true
			}
		});
		return response;
	},

	recoverPassword(email) {

		var response = Repository.post('User/RecoverPassword', {
			email: email
		});

		return response;
	},

	resetPassword(userId, password, token) {

		var response = Repository.post('User/ResetPassword', {
			userId: userId,
			password: password,
			token: token 
		});

		return response;
	},

	updatePassword(userId, password) {
		var response = Repository.patch('User/UpdateUser', {
			userId: userId,
			password: password
		});
		return response;
	},

	updateUser(userId, emailAddress, firstname, surname, vendorCode, deactivate, password) {
		var response = Repository.patch('User/UpdateUser', {
			userId: userId,
			emailAddress: emailAddress,
			firstname: firstname,
			surname: surname,
			vendorCode: vendorCode,
			deactivate: deactivate,
			password: (password != '') ? password : null
		});
		return response;
	},

}
